import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AccessibilityState {
  userIncreasedFontSize: boolean;
  systemFontScale: number;
}

const initialState: AccessibilityState = {
  userIncreasedFontSize: false,
  systemFontScale: 1.0,
};

const accessibilitySlice = createSlice({
  name: 'accessibility',
  initialState,
  reducers: {
    setUserIncreasedFontSize(state, action: PayloadAction<boolean>) {
      state.userIncreasedFontSize = action.payload;
    },
    setSystemFontScale(state, action: PayloadAction<number>) {
      state.systemFontScale = action.payload;
    },
    resetFontScale: (state) => {
      state.systemFontScale = 1.0;
      state.userIncreasedFontSize = false;
    }
  },
});

export const { setUserIncreasedFontSize, setSystemFontScale, resetFontScale } = accessibilitySlice.actions;
export default accessibilitySlice.reducer;  